module.exports = __webpack_public_path__ + "video-cover-2x-49d1e1119c4214347ef988e67b9842c1.webp";